import { Inject, Injectable, InjectionToken } from '@angular/core';
import CryptoJS from 'crypto-js';
import { AppConfigService } from 'src/app/Service/Configuration/app-config.service';
import { environment } from 'src/environments/environment';
export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => localStorage
});
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor(@Inject(BROWSER_STORAGE) public storage: Storage,
    private appConfig: AppConfigService) { }

  public set(key: string, data: string): void {
    if (data != null && data != undefined)
      this.storage.setItem(key, CryptoJS.AES.encrypt(data, this.appConfig.setting.pass))
  }

  public get(key: string): string {
    if (this.storage.getItem(key) == null || this.storage.getItem(key) == undefined)
      return null;
    else
      try {
        return CryptoJS.AES.decrypt(this.storage.getItem(key), this.appConfig.setting.pass).toString(CryptoJS.enc.Utf8);
      } catch (error) {
        return this.storage.getItem(key);
      }
  }
  remove(remItem) {
    this.storage.removeItem(remItem);
  }
  removeAll() {
    this.storage.clear();
  }
}